import { render, staticRenderFns } from "./ContractStatisticsList.vue?vue&type=template&id=2aab84ee&scoped=true&"
import script from "./ContractStatisticsList.vue?vue&type=script&lang=js&"
export * from "./ContractStatisticsList.vue?vue&type=script&lang=js&"
import style0 from "./ContractStatisticsList.vue?vue&type=style&index=0&id=2aab84ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab84ee",
  null
  
)

export default component.exports